import React from 'react';
import sharedTable from '../../images/sharedTable.jpg';

export function Header() {
  return <img src={sharedTable} alt="logo" width="100%" />;
}
